import { Component, computed, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { buildFinalReport } from '../../domain/final-report';
import { apiErrorCode, apiErrorMessage, apiErrorStatus } from '../../services/api-error';
import { PlayerSessionService } from '../../services/player-session.service';
import { PublicOperationService } from '../../services/public-operation.service';
import { Dossier } from '../../shared/dossier/dossier';
import { PageTitle } from '../../shared/page-title/page-title';
import { Podium } from '../../shared/podium/podium';
import { RankingTable } from '../../shared/ranking-table/ranking-table';
import { StatePanel } from '../../shared/state-panel/state-panel';

// Rapport final d'une operation terminee : podium, classement, chasseurs (TD-021).
// Le bilan personnel s'affiche pour un joueur dont un nom de code figure au classement.
@Component({
  selector: 'app-victory-page',
  imports: [Dossier, PageTitle, Podium, RankingTable, RouterLink, StatePanel],
  templateUrl: './victory-page.html',
  styleUrl: './victory-page.scss',
})
export class VictoryPage {
  readonly operationId = input.required<string>();

  private readonly publicOperations = inject(PublicOperationService);
  private readonly sessions = inject(PlayerSessionService).sessions;

  protected readonly operation = this.publicOperations.operation(() => this.operationId());
  protected readonly eliminations = this.publicOperations.eliminations(() => this.operationId());

  protected readonly report = computed(() =>
    buildFinalReport(this.operation.value()?.ranking ?? [], this.eliminations.value() ?? []),
  );
  protected readonly self = computed(() => {
    const codeNames = new Set(this.sessions().map(({ codeName }) => codeName));
    return this.report().find((entry) => codeNames.has(entry.codeName)) ?? null;
  });
  protected readonly notComplete = computed(
    () => apiErrorCode(this.eliminations.error()) === 'OPERATION_NOT_COMPLETE',
  );
  protected readonly notFound = computed(
    () =>
      apiErrorStatus(this.operation.error()) === 404 ||
      apiErrorStatus(this.eliminations.error()) === 404,
  );
  protected readonly loadError = computed(() => {
    const error = this.operation.error() ?? this.eliminations.error();
    return error && !this.notComplete() && !this.notFound() ? apiErrorMessage(error) : null;
  });
}
